import { render, staticRenderFns } from "./ColumnUserGou.vue?vue&type=template&id=12a85ebc"
import script from "./ColumnUserGou.vue?vue&type=script&lang=js"
export * from "./ColumnUserGou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports